/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  User Invitation Dialog
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStores } from 'stores/RootStore';
import { firebase } from 'containers/services/Firebase';

// Design System
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

function UserInvite(props) {
  const { type, id, open } = props;
  const classes = styles();
  const stores = useStores();
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');

  const handleChange = e => {
    if (e.target.id === 'email') {
      setEmail(e.target.value);
    } else {
      setRole(e.target.value);
    }
  };

  const handleClose = e => {
    if (props.handleClose) {
      setRole('');
      props.handleClose(e);
    }
  };

  const onSubmit = e => {
    e.preventDefault();

    if (email !== '' && role !== '') {
      let invite = {
        invitedBy: {
          uid: stores.authStore.currentUser.uid,
          name: stores.userStore.user.displayName,
          email: stores.userStore.user.email,
          companyId: stores.authStore.claims.companyId,
        },
        companyId: stores.authStore.claims.companyId,
        companyName: stores.companyStore.company.name,
        locationId: props.type === 'company' ? null : stores.locationStore.location.id,
        email: email,
        type: type,
        id: id,
        role: role,
      };
      firebase
        .inviteNewUser(invite)
        .then(() => {
          // Success
          stores.portalStore.snackbar.showSnackbarWithVariantWithDuration(
            'User invite sent successfully.',
            'success',
            3500
          );
          if (type === 'location') {
            // Refresh invite location store list
            stores.locationStore.getUserInvites();
          } else if (type === 'company') {
            // Refresh invite company store list
            stores.companyStore.getInvites();
          }
          handleClose(e);
        })
        .catch(error => {
          stores.rootStore.appStore.error('system', error);
          handleClose(e);
        });
    }
  };

  return (
    <form autoComplete='on' action='' onSubmit={onSubmit}>
      <Dialog open={open} onClose={handleClose} aria-labelledby='New User Invite'>
        <DialogTitle id='form-dialog-title'>New User Invitation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please add the user's email address and role below. Once invited, the user will receive an email with
            further instructions.
          </DialogContentText>
          <Grid container direction='row' alignItems='center'>
            <Grid item xs={12} sm={8}>
              <TextField
                autoFocus
                margin='dense'
                id='email'
                label='Email Address'
                type='email'
                fullWidth
                required
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl className={classes.formControl} margin='dense'>
                <InputLabel htmlFor='role'>Role</InputLabel>
                <Select
                  value={role}
                  onChange={handleChange}
                  inputProps={{
                    name: 'role',
                    id: 'role',
                  }}
                >
                  <MenuItem value={'Admin'}>Admin</MenuItem>
                  <MenuItem value={'User'}>User</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Cancel
          </Button>
          <Button disabled={email === '' || role === ''} color='primary' type='button' onClick={onSubmit}>
            Invite
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}

UserInvite.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  handleClose: PropTypes.func,
};

const styles = makeStyles(theme => ({
  root: {},
  formControl: {
    marginLeft: '15px',
    minWidth: 120,
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0px',
    },
  },
  selectEmpty: {},
}));

export default UserInvite;
